export default "/1.a0e3775fb648260e0a0b594e0c378a1a.png";